import React from "react";

export const Subtract = () => {
  return (
    <svg width="13" height="4" viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 2.53125H7.35714H5.64286H0.5V0.53125H5.64286H7.35714H12.5V2.53125Z" fill="#F87FB1" stroke="#F87FB1"/>
    </svg>
  );
};
